module.exports = __webpack_public_path__ + "static/dog-3da570ad0e6d6847409b6da5e40c0a0f.png";